















import { Component, Vue, Prop } from 'nuxt-property-decorator';
import HeaderMenuNotificationsCardGrid from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import type { Notification, Post } from '@/types/graphql';

@Component<HeaderMenuNotificationsCardMobileAppPost>({
  components: {
    HeaderMenuNotificationsCardGrid,
  },
})
export default class HeaderMenuNotificationsCardMobileAppPost extends Vue {
  @Prop({ required: true }) notification!: Notification;

  get referenceable(): Post | null {
    return this.notification.referenceable as Post;
  }

  get title() {
    return this.referenceable?.content.title;
  }
}
